import ePower from '../views/ePower'

export default {
  path: '/ePower',
  component: ePower,
  redirect: '/ePower/lifeInfo',
  name: 'ePower',
  meta: {
    title: '党建赋能站'
  },
  children: [
    {
      path: '/ePower/lifeInfo',
      component: () => import('../views/ePower/LifeInfo'),
      name: 'LifeInfo',
      meta: { title: '组织生活' }
    },
    {
      path: '/ePower/education',
      component: () => import('../views/ePower/Education'),
      name: 'Education',
      meta: { title: '主题教育' }
    },
    {
      path: '/ePower/partyBuilding',
      component: () => import('../views/ePower/PartyBuilding'),
      name: 'PartyBuilding',
      meta: { title: '党建品牌' }
    },
    {
      path: '/ePower/connection',
      component: () => import('../views/ePower/Connection'),
      name: 'Connection',
      meta: { title: '村集体经济' }
    }
  ]
}
